import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDesignSystem16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconDesignSystem16"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#DesignSystem16)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="m13.56 4.089-1.65-1.651-1.268 1.267 1.65 1.651zM3.726 10.62l6.208-6.208 1.651 1.651-6.208 6.208-2.117.466zm7.54-2.823 3.001-3.001a1 1 0 0 0 0-1.415l-1.65-1.65a1 1 0 0 0-1.415 0L8.2 4.732l-2.85-2.85a1.5 1.5 0 0 0-2.122 0L1.88 3.23a1.5 1.5 0 0 0 0 2.12l2.85 2.852-1.917 1.918-.53 2.402a1 1 0 0 0 1.192 1.192l2.403-.529 1.918-1.918 2.852 2.852a1.5 1.5 0 0 0 2.121 0l1.349-1.348a1.5 1.5 0 0 0 0-2.122zm-.708.707L8.503 10.56l2.852 2.852a.5.5 0 0 0 .707 0l1.349-1.348a.5.5 0 0 0 0-.707l-1.031-1.031-.026.028-1 1a.5.5 0 1 1-.707-.707l1-1 .028-.026zm-5.12-1.01-2.851-2.85a.5.5 0 0 1 0-.707l1.348-1.349a.5.5 0 0 1 .707 0l1.033 1.033-.029.026-1 1a.5.5 0 0 0 .707.707l1-1 .027-.028 1.113 1.113z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="DesignSystem16">
                        <path fill="#fff" d="M0 0h16v16H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconDesignSystem16);
